import React from 'react'
import PageHeader from '../components/PageHeader'
import PriceBanner from '../components/PriceBanner'
import ContactForm from '../components/ContactForm'
import { COMPANY_INFO } from '../lib/constants'
import { getOptimizedImageUrl } from '../lib/cms'

export default function OmJakob() {
  const profileImg = 'https://assets.auxodev.dk/assets/ea5c97a8-a563-48d7-8fa0-939f59c0351d/fd248068-b038-4b6e-bb81-80419e4e7af8.jpg'

  return (
    <div className="space-y-16">
      <PageHeader
        badge="Enkeltmandsforretning"
        title="Om Jakob & Virksomheden"
        subtitle="25 års praktisk erfaring, eget specialudstyr og direkte kontakt til den fagmand, der udfører opgaven."
        breadcrumb="Om Jakob"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-8 space-y-8">
            {/* Scrape fidelity text */}
            <div className="bg-white rounded-3xl border border-slate-200 p-8 sm:p-10 shadow-sm space-y-6">
              <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-[#55565C]">
                <span className="w-1.5 h-1.5 rounded-full bg-[#E36C0A]" aria-hidden="true" />
                <span>Mød din elektriker</span>
              </div>
              <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight">
                Grundig og altid smilende elektriker
              </h2>

              <div className="prose max-w-none text-slate-700 font-normal leading-relaxed space-y-4">
                <p className="text-base sm:text-lg font-normal text-slate-900">
                  jakobelektriker er en enkeltmands forretning.
                </p>
                <p className="font-normal">
                  Grundig og altid smilende elektriker, der arbejder med høj faglig erfaring. Kan selv grave løse grave opgaver og arbejde i op til 8 meters højde til DK's absolutte billigste priser. Altid frisk på at løse en opgave stor som lille, også uden for elfaget. Jeg sparer med andre selvstændige håndværkere.
                </p>
                <p className="font-normal">
                  Mine 25 års erfaring som elektriker, både som service elektriker i mindre og større private opgaver og især som ny byg og renoverings elektriker for både privat og erhverv, gør jeg har prøvet det meste. Fra opgaver indenfor total renovering af sommerhuset til at planlægge, lede og fordele arbejdet i store byggesager der har taget op mod 3 år at gennemføre.
                </p>
                <p className="font-normal">
                  Endelig hvad koster det? Jeg tager 485,- ex moms pr. time, her i er servicevognen i regnet. For mig er en time en time, uden skjulte tillæg.
                </p>
                <p className="font-normal italic">
                  Jeg er fuldt ud forsikret om jeg arbejder med din el installation, arbejde i højden nær din bygning eller graver i din have
                </p>
                <div className="pt-4 font-normal text-slate-900">
                  <p>mvh Jakob elektriker</p>
                </div>
              </div>
            </div>

            {/* Værdier & tilgang */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="bg-white rounded-2xl p-6 border border-slate-200 shadow-sm space-y-2">
                <div className="w-10 h-10 rounded-xl bg-slate-900 text-amber-400 flex items-center justify-center text-lg">
                  <i className="fa-solid fa-comments" aria-hidden="true" />
                </div>
                <h3 className="font-bold text-slate-900 text-base">
                  Direkte dialog
                </h3>
                <p className="text-xs sm:text-sm text-slate-600 leading-relaxed">
                  Du aftaler altid opgaven direkte med Jakob. Ingen misforståelser, intet unødvendigt papirarbejde.
                </p>
              </div>

              <div className="bg-white rounded-2xl p-6 border border-slate-200 shadow-sm space-y-2">
                <div className="w-10 h-10 rounded-xl bg-slate-900 text-amber-400 flex items-center justify-center text-lg">
                  <i className="fa-solid fa-wrench" aria-hidden="true" />
                </div>
                <h3 className="font-bold text-slate-900 text-base">
                  Løsningsorienteret tilgang
                </h3>
                <p className="text-xs sm:text-sm text-slate-600 leading-relaxed">
                  Jakob siger selv fra på forhånd, hvis en opgave ikke matcher hans ekspertise. Ærlighed og kvalitet først.
                </p>
              </div>
            </div>
          </div>

          {/* Profile Sidebar */}
          <div className="lg:col-span-4 space-y-6">
            <div className="bg-white rounded-3xl border border-slate-200 overflow-hidden shadow-sm">
              <img
                src={getOptimizedImageUrl(profileImg, { width: 700, quality: 85 })}
                alt="Jakob elektriker på arbejdssted"
                className="w-full aspect-4/3 object-cover object-center"
              />
              <div className="p-6 space-y-3">
                <div className="flex items-center justify-between">
                  <span className="font-extrabold text-xl text-slate-900">Jakob</span>
                  <span className="bg-slate-100 text-[#55565C] text-xs font-bold px-2.5 py-1 rounded-full">
                    25 års erfaring
                  </span>
                </div>
                <p className="text-xs text-[#55565C] leading-relaxed">
                  Selvstændig elektriker med base i Rynkeby på Fyn. Kører ud til private boligejere, entreprenører og virksomheder.
                </p>

                <div className="pt-3 border-t border-slate-100 space-y-2 text-xs">
                  <div className="flex items-center gap-2 text-slate-700">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#E36C0A]" aria-hidden="true" />
                    <a href={`tel:${COMPANY_INFO.phoneRaw}`} className="font-bold hover:text-[#E36C0A]">
                      {COMPANY_INFO.phone}
                    </a>
                  </div>
                  <div className="flex items-center gap-2 text-slate-700">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#E36C0A]" aria-hidden="true" />
                    <a href={`mailto:${COMPANY_INFO.email}`} className="hover:text-[#E36C0A]">
                      {COMPANY_INFO.email}
                    </a>
                  </div>
                  <div className="flex items-center gap-2 text-slate-700">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#E36C0A]" aria-hidden="true" />
                    <span>{COMPANY_INFO.address}, {COMPANY_INFO.postal} {COMPANY_INFO.city}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Price Banner */}
        <PriceBanner showCablePrice={true} />

        {/* Contact Form Section */}
        <div className="my-12">
          <ContactForm />
        </div>
      </div>
    </div>
  )
}
